import React from "react";
import WallOfReceipts from "../components/receipts/WallOfReceipts";
import { useSavings } from "../context/SavingsContext";

const ReceiptsPage: React.FC = () => {
  const { loading, error } = useSavings();

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="text-2xl">Loading savings data...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-red-800 text-white p-6 rounded-lg">
        <h2 className="text-xl font-bold mb-2">Error</h2>
        <p>{error}</p>
      </div>
    );
  }

  return (
    <div>
      <div className="mb-8">
        <h1 className="text-3xl font-bold mb-4">Wall of Receipts</h1>
        <p className="text-gray-300">
          Detailed breakdown of all cost savings initiatives at West Coast
          Drywall & Paint.
        </p>
      </div>

      <WallOfReceipts />
    </div>
  );
};

export default ReceiptsPage;
